import { HeatingCircuit, Pza } from 'z3k-parser/model/z3k-config';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
export function findLinksToPzaAndRemove(config, pza_id) {
    if (!HeatingCircuit.get.some(config, (hc) => hc.pza === pza_id) ||
        !HeatingMode.get.some(config, ({ heating_zones }) => heating_zones.some((hz) => hz.pza === pza_id))) {
        return Pza.get.removeById(config, pza_id);
    }
    return config;
}
